import { createContext, useContext, useEffect, useRef, useState } from 'react';

export type ModalContextValue<T = unknown> = {
  confirm: (data?: T) => void;
  dismiss: (data?: T) => void;
};

export const ModalContext = createContext<ModalContextValue>({
  confirm: () => {},
  dismiss: () => {},
});

export const useModalContext = () => useContext(ModalContext);

export const useHandleBodyClick = ({ onClick }: { onClick: (e: MouseEvent) => void }) => {
  const [ref, setRef] = useState<HTMLElement | null>(null);
  const onClickRef = useRef<typeof onClick>();
  onClickRef.current = onClick;

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const isRefClicked = ref === event.target || ref?.contains(event.target as Node);
      if (!isRefClicked) {
        onClickRef.current?.(event);
      }
    };
    document.body.addEventListener('click', handleClick);
    return () => document.body.removeEventListener('click', handleClick);
  }, [ref]);

  return {
    ref: setRef,
  };
};
